export const paragraph = (param: string) => {
  return `

      <p class="paragraph">${param}</p>

  `;
};
